import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

import { OptionToolbar, OptionToolbarData, Toolbar } from '@mirage-projects/cw-commons';
import { JobSite } from '@mirage-projects/cw-models';
import { MapPcvizService } from '@mirage-projects/cw-pcviz-core';

@Component({
    selector: 'cw-sites-map',
    templateUrl: './sites-map.component.html',
    styleUrls: ['./sites-map.component.scss'],
    standalone: false,
})
export class SitesMapComponent implements AfterViewInit, OnChanges {
    /** list of sites to be showned in the map */
    @Input() jobSitesList!: JobSite[];

    /** emits when a site is selected*/
    @Output() selectedJobSite = new EventEmitter<JobSite>();

    sitesMapViewer: any;
    isLoading = true;
    toolbar!: Toolbar;

    @ViewChild('containerSitesMap') containerMap!: ElementRef;
    @ViewChild('sitesMap') mapElement!: ElementRef;

    constructor(private mapPcvizService: MapPcvizService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['jobSitesList'] && changes['jobSitesList'].currentValue !== changes['jobSitesList'].previousValue) {
            this.renderSites();
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            /*
            This timeout is necessary for the layer to have its properties initialized.
            Otherwise, the height and width would be 0 and the Open Layers initialization would fail.
            */
            this.init();
        }, 0);
        const observer = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            const height = entries[0].contentRect.height;
            if (this.sitesMapViewer?._olMap) {
                this.sitesMapViewer._olMap.setSize([width, height]);
            }
        });
        observer.observe(this.containerMap.nativeElement);
    }

    async init(): Promise<void> {
        this.toolbar = this.getToolbar();
        this.sitesMapViewer = this.mapPcvizService.createSitesMapViewer(this.mapElement.nativeElement);
        this.sitesMapViewer.setSelectedJobSiteFn((jobSite: JobSite) => {
            this.onSelectedJobSite(jobSite);
        });

        // Run map view and render sites pins
        this.sitesMapViewer.run();
        this.renderSites();
    }

    onSelectedJobSite(jobSite: JobSite): void {
        this.selectedJobSite.emit(jobSite);
    }

    isResetExtentEnabled(): boolean {
        return this.jobSitesList.some((jobSite: JobSite) => !!jobSite.horizProjectionEPSG);
    }

    resetExtent(): void {
        this.sitesMapViewer.fitSitesMap();
    }

    onSelectOption(option: OptionToolbarData): void {
        if (option.id === 'resetExtentSitesMap') {
            this.resetExtent();
        }
    }

    private async renderSites(): Promise<void> {
        if (!this.sitesMapViewer) {
            return;
        }
        this.isLoading = true;
        await this.sitesMapViewer.renderSitesList(this.jobSitesList, true);
        this.isLoading = false;
    }

    private getToolbar(): Toolbar {
        const options: OptionToolbar[] = [
            {
                data: { id: 'resetExtentSitesMap', widget: 'jobSite' },
                icon: 'full-screen',
                tooltip: 'VIEW3D.RESET_EXTENT',
                placementTooltip: 'bottom-left',
            },
        ];
        const toolbar: Toolbar = {
            options,
            orientation: 'horizontal',
        };
        return toolbar;
    }
}
